import React from "react";
import styles from "./ToggleSwitch.module.css";

const ToggleSwitch = ( { isOn, onToggle, dimmed=false } ) => {
	const switchWrapperBgColor = isOn ? "#cddfc3" : "#dbb6b6";
	const switchBgColor = isOn ? "#4dcf04" : "#ed4141";

	return (
		<div className={`${styles.switch_wrapper} ${dimmed ? styles.dimmed : ""}`} style={{ backgroundColor: switchWrapperBgColor }}>
			<div className={`${styles.switch} ${isOn ? styles.slideRight : styles.slideLeft}`} style={{ backgroundColor: switchBgColor }} onClick={onToggle}></div>
		</div>
	);
};

export default ToggleSwitch;